// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"77f9f5c2","652":"85a210c1","715":"d44d4a66","739":"cfc09692","747":"9cf06524"}[chunkId] + ".chunk.css";
};